exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.button[data-v-f8856b0a] {\n  background-color: #ff6c00 !important;\n  max-height: 75% !important;\n}\n", ""]);

// exports
